export default function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
}
//# sourceMappingURL=clamp.js.map